import { useEffect, useState } from "react";
import { Drawer } from "../../shared/components/Drawer";
import { Button } from "../../shared/components/Button";
import { EnvironmentsAPI } from "../../providers/EnvironmentsAPI";
import { EnvironmentStorage } from "../../shared/tools/EnvironmentStorage";
import { Radio } from "../../shared/components/Radio";
import { Label } from "../../shared/components/Label";
import { CatalogAPI } from "../../providers/CatalogAPI";

export const BrandCloneCatalog = ({ visible, onSuccesfull, onClose }) => {
    const [loading, setLoading] = useState(false);
    const [units, setUnits] = useState([]);
    const [selectedUnit, setSelectedUnit] = useState(null);

    useEffect(() => {
        const loadUnits = async () => {
            const unitsResponse = await EnvironmentsAPI.getUnits(
                EnvironmentStorage.getSelectedEnvironment()
            );
            setUnits(unitsResponse.getData({ units: [] }).units);
        }

        if (visible) {
            loadUnits();
        }
    }, [visible]);

    const handleSubmit = async () => {
        setLoading(true);
        const environmentId = EnvironmentStorage.getSelectedEnvironment();
        const referenceCatalogResponse = await CatalogAPI.getCatalogByService(selectedUnit.id, 'DELIVERY');
        const savedCatalogResponse = await CatalogAPI.putCatalog(referenceCatalogResponse.getData({}), 'DELIVERY');
        const configResponse = await EnvironmentsAPI.putConfigurationsByAlias(environmentId, 'catalog_imported', {
            catalog_imported: {
                date: new Date,
                unitId: selectedUnit.id,
                name: selectedUnit.name
            }
        });
        setLoading(false);
        onSuccesfull && onSuccesfull();
    }

    return (
        <Drawer
            visible={visible}
            onClose={() => onClose()}
            title="Importar cardápio"
            footer={
                <Button
                    design="primary"
                    className="w-100"
                    disabled={!selectedUnit || loading}
                    loading={loading}
                    onClick={handleSubmit}
                >
                    Importar
                </Button>
            }
            withoutTransition
        >
            <Label>Selecione uma unidade como base</Label>
            {units.map((u) => {
                return (
                    <Radio
                        className="mb-5"
                        family="unit"
                        checked={selectedUnit && selectedUnit.id}
                        value={u.id}
                        onChange={() => setSelectedUnit(u)}
                    >
                        {u.name}
                    </Radio>
                )
            })}
        </Drawer>
    );
}